/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { Login } from "./components/Login";
import { SSO } from "./components/SSO";
import { toAbsoluteUrl } from "../../../_metronic/helpers";

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  return (
    <div
      className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
      style={{
        backgroundImage: `url(${toAbsoluteUrl("/media/illustrations/sketchy-1/14.png")})`
      }}
    >
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        {/* begin::Logo */}
        <a href="#" className="mb-12">
          <img alt="Logo" src={toAbsoluteUrl("/keylid.svg")} className="h-45px" />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <Outlet />
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-10">
        <div className="d-flex align-items-center fw-bold fs-6">
          <a href="https://kplus.holdings/" className="text-muted text-hover-primary px-2">
            درباره ما
          </a>

          <a href="https://kplus.holdings/contact" className="text-muted text-hover-primary px-2">
            تماس با ما
          </a>

          <a href="https://kplus.holdings/contact" className="text-muted text-hover-primary px-2">
            قوانین و مقررات
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      <Route path="sso" element={<SSO />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export { AuthPage };
